import React from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useNavigate, useParams } from "react-router-dom";
import NoDataFound from "../../../components/NoDataFound";
import ApplicationSkeleton from "../../../components/Skeleton/Application";
import { useScrollDirectionClass } from "../../../components/ForMobile/useScrollDirectionClass";

import InfiniteScroll from "react-infinite-scroll-component";
import { defaultLogo } from "../../../Icons";
const { GridView, SimCheckBox, ApplicationCard } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ApplicationsList = ({
  showCheckbox = true,
  loading,
  list,
  handleSelectItems,
  selectedItems,
  handleAppClick,
  hasMore,
  loadMoreData,
  isMobileView,
}) => {
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);
  const params = useParams();
  const UUID = params?.uuid;

  const handleLoadMoreData = () => {
    if (loadMoreData) {
      loadMoreData();
    }
  };
  useScrollDirectionClass();

  return (
    <>
      <div id="scrollableDivApplication" className="scrollable-container">
        {loading ? (
          <ApplicationSkeleton length={10} />
        ) : list.length > 0 ? (
          <InfiniteScroll
            scrollThreshold={0.7}
            dataLength={list.length}
            next={handleLoadMoreData}
            hasMore={hasMore}
            loader={<ApplicationSkeleton length={5} />}
            scrollableTarget="scrollableDivApplication"
          >
            <div className="groups-tab">
              <GridView>
                {list.map((app, i) => {
                  return (
                    <ApplicationCard
                      key={i}
                      assignedResources={app.assignedResource}
                      showResources={false}
                      showOpenBtn={true}
                      name={app.name}
                      description={app.description}
                      logo={app.icon || defaultLogo}
                      inActive={true}
                      showCheckbox={!app.inherit && showCheckbox && UUID !== userData.user.group.uuid}
                      checked={false}
                      resourceClick={() => navigate(`/team-management/Application/${app.uuid}`)}
                      onClick={() =>
                        selectedItems.length > 0
                          ? handleSelectItems({ id: app.uuid, data: app })
                          : handleAppClick(app.uuid)
                      }
                      // checkbox={
                      //   <SimCheckBox
                      //     onChange={() => handleSelectItems({ id: app.uuid, data: app })}
                      //     checked={selectedItems.some((item) => item.id === app.uuid)}
                      //     disabled={app.inherit ?? false}
                      //   />
                      // }

                      checkbox={
                        !isMobileView ? (
                          <SimCheckBox
                            onChange={() => handleSelectItems({ id: app.uuid, data: app })}
                            checked={selectedItems.some((item) => item.id === app.uuid)}
                            disabled={app.inherit ?? false}
                          />
                        ) : (
                          false
                        )
                      }
                    />
                  );
                })}
              </GridView>
            </div>
          </InfiniteScroll>
        ) : (
          <div className="no-data">
            <NoDataFound headText="No Application found" infoText="" />
          </div>
        )}
      </div>
    </>
  );
};

export default ApplicationsList;
